<template>
  <v-container id="contact" tag="section">
    <base-card class="pa-3" :color="sectionColor">
      <v-container>
        <v-row>
          <v-col>
            <base-subheading>Contact</base-subheading>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" class="mt-n8">
          <v-col md="8" lg="6">
            <v-list class="transparent">
              <v-list-item
                v-for="(methodOfContact,
                index) in methodsOfContactForContactSection"
                :key="index"
              >
                <v-list-item-avatar color="primary">
                  <v-btn
                    dark
                    icon
                    :href="methodOfContact.url"
                    :small="$vuetify.breakpoint.smAndDown"
                    @click="logAnalyticEvent(methodOfContact.name)"
                  >
                    <v-icon>
                      {{ methodOfContact.icon }}
                    </v-icon>
                  </v-btn>
                </v-list-item-avatar>

                <v-list-item-title class="hidden-sm-and-down">
                  {{ methodOfContact.name.toUpperCase() }}
                </v-list-item-title>

                <v-list-item-subtitle>
                  {{ methodOfContact.value }}
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <iframe
              height="300"
              width="100%"
              src="https://maps.google.com/?q=8430%20N%20700%20W%20Ligonier%2C%20IN%2C%2046767&t=&z=13&ie=UTF8&iwloc=&output=embed"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
            />
          </v-col>
        </v-row>
      </v-container>
    </base-card>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "Contact",
  methods: {
    logAnalyticEvent(eventType) {
      this.$gtag.event(`${eventType.toLowerCase()}`, {
        event_category: "contact",
      });
    },
  },
  computed: {
    ...mapGetters(["methodsOfContactForContactSection"]),
    ...mapState(["sectionColor"]),
  },
};
</script>
